/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';
import { CursorManager } from '../../core/navigation';

const CursorEvents: FunctionComponent = (): JSX.Element => {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const data = event?.data;
            if (data.type !== CursorManager.SERVICE_NAME) {
                return;
            }

            CursorManager.onChange(data.response?.visibility);
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return <></>;
};

export default CursorEvents;
